import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';

@Component({
  imports: [ButtonModule],
  templateUrl: './logged-out-modal.component.html',
  styleUrl: './logged-out-modal.component.scss'
})
export class LoggedOutModalComponent {

  constructor(public bsModalRef: BsModalRef) { }

  public backToLogin() {
    if (window.location.origin.startsWith("http://localhost") || window.location.origin.startsWith("https://dev-ki-toolbox.reflactportal.com")) {
      window.location.href = 'https://portal-dev.reflact.info/';
    } else {
      window.location.href = 'https://reflactportal.com/';
    }
  }
}
